import { render } from "./sso_univ.vue?vue&type=template&id=57378d64"
import script from "./sso_univ.vue?vue&type=script&lang=js"
export * from "./sso_univ.vue?vue&type=script&lang=js"

import "../login/css/login.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__